/* @flow weak */
import * as React from 'react';
import PropTypes from 'prop-types';
import shallowCompare from 'react-addons-shallow-compare';

import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import ModalTrigger from 'components/ModalTrigger';
import RelationshipModal from 'user/components/RelationshipModal';
import UserLink from 'users/components/UserLink';
import UserAvatar from 'users/components/UserAvatar';

import './styles/GroupMessageHeader.scss';

const SenderIcon = ({ iconUrl, initials, isSender }) => {
  if (iconUrl) {
    return <Image src={iconUrl} circle />;
  } else if (isSender) {
    return <UserAvatar size="small" color="white" user={{ initials }} />;
  } else {
    return <UserAvatar size="small" user={{ initials }} />;
  }
};
SenderIcon.propTypes = {
  iconUrl: PropTypes.string,
  initials: PropTypes.string,
  isSender: PropTypes.bool,
};

class GroupMessageHeader extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    iconUrl: PropTypes.string,
    author: PropTypes.string,
    initials: PropTypes.string,
    senderId: PropTypes.number.isRequired,
  };

  static contextTypes = {
    group: PropTypes.instanceOf(Group),
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      shallowCompare(this, nextProps, nextState) || !!nextContext.group !== !!this.context.group
    );
  }

  renderAuthor = () => {
    const { group } = this.context;
    const { author, iconUrl, initials, senderId } = this.props;

    const isSignout = !CurrentUser.isSignedIn();
    const isSender = !isSignout && CurrentUser.getUserId() === senderId;

    const iconProps = { iconUrl, initials, isSender };

    // the group is not in the context in the message viewer
    // even when signed in we can't show the user modal because
    // of code splitting
    if (!group || isSignout || isSender) {
      return (
        <div className="GroupMessageHeader-author">
          <SenderIcon {...iconProps} />
          {author}
        </div>
      );
    }

    const modal = <RelationshipModal userId={senderId} />;

    return (
      <span>
        <ModalTrigger modal={modal}>
          <UserLink
            className="GroupMessageHeader-author"
            userId={senderId}
            placement="right"
            color="pitch"
            alignment="top">
            <SenderIcon {...iconProps} />
            {author}
          </UserLink>
        </ModalTrigger>
      </span>
    );
  };

  render() {
    return (
      <MediaObject className="GroupMessageHeader" figure="right">
        {this.renderAuthor()}
        {this.props.children}
      </MediaObject>
    );
  }
}

export default GroupMessageHeader;
